import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaRangePicker = Loadable({
  loader: () => import("./RangePicker"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaRangePicker;



// WEBPACK FOOTER //
// ./ecology9/wea-range-picker/index.js